import axios from "./config/axios"

export const getInfo = () => axios.get("/affiliates/info?lang=pt_BR")

export const getReferralLinks = () =>
  axios.get("/affiliates/referral_links?lang=pt_BR")

export const getProgress = () =>
  axios.get("/affiliates/progress_info?lang=pt_BR")
